/**
 * Ordered list of emoji characters available for chat reactions.
 * @see {@link /app/_config/chat-reactions.yml}
 */
export const AVAILABLE_REACTIONS: string[] = [
    '👍',
    '❤️',
    '😂',
    '😢',
    '🔥',
    '🎉',
];
